import isEmpty from 'lodash/isEmpty'

import {
  getAccountName,
  getWorkspace,
} from '@/checkout-instore-legacy/utils/UrlUtils'
import { getIntlLocale } from '@/checkout-instore-legacy/i18n/utils'

import { DEFAULT_TIMEOUT } from './constants'

let loadedExtensions = {}

export function createExtensionLoaders(paths, timeout = DEFAULT_TIMEOUT) {
  if (isEmpty(paths) || !window.RenderExtensionLoader) {
    return null
  }

  const baseLoaderOptions = {
    account: getAccountName(),
    workspace: getWorkspace(),
    locale: getIntlLocale(),
    timeout,
  }

  if (Array.isArray(paths)) {
    return paths.map(
      (path) =>
        new window.RenderExtensionLoader({
          ...baseLoaderOptions,
          path: path,
        })
    )
  }

  return new window.RenderExtensionLoader({
    ...baseLoaderOptions,
    path: paths,
  })
}

export function resetLoadersCache() {
  loadedExtensions = {}
}

export function loadExtensions(paths, timeout = DEFAULT_TIMEOUT) {
  const loaders = createExtensionLoaders(paths, timeout)
  if (isEmpty(loaders)) {
    return Promise.reject(null)
  }

  if (!Array.isArray(loaders)) {
    const loader = loaders

    if (loadedExtensions[loader.path]) {
      return Promise.resolve(loadedExtensions[loader.path])
    }

    return loader
      .load()
      .then((runtime) => {
        loadedExtensions[loader.path] = loader
        loader.runtime = runtime
        return loader
      })
      .catch((error) => {
        console.error('loadExtensions error', error)
        return Promise.resolve(null)
      })
  }

  return Promise.all(
    loaders.map((loader) => {
      if (loadedExtensions[loader.path]) {
        return Promise.resolve(loadedExtensions[loader.path])
      }

      return loader
        .load()
        .then((runtime) => {
          loadedExtensions[loader.path] = loader
          loader.runtime = runtime
          return loader
        })
        .catch((error) => {
          console.error('loadExtensions error', error)
          return Promise.resolve(null)
        })
    })
  )
}
